"use strict";

exports.__esModule = true;
exports.TicketRoutes = TicketRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute/CheckAccessRoute");
var _TicketListScreen = require("../TicketListScreen");
var _TicketWatcherRuleListScreen = require("../TicketWatcherRuleListScreen");
var _TicketTypesScreen = require("../../TicketTypes/TicketTypesScreen");
var _System = require("../../../System");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _TicketDetails = require("../TicketDetails");
var _UhOh = require("../../Core/UhOh");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Override global settings for the layout here, see LayoutSettingsController for defaults
var settings = {
  selection: {
    allowReportingPeriod: true
  }
};

/**
 * Routes for the ticketing.
 */
function TicketRoutes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("TicketWatcherRuleList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_TICKETING",
      component: _TicketWatcherRuleListScreen.TicketWatcherRuleListScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("TicketDetails"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_TICKETING",
      render: function render(props) {
        var ticketId = props.match.params.id;
        if (ticketId) {
          return /*#__PURE__*/_react["default"].createElement(_TicketDetails.TicketDetails, _extends({}, props, {
            ticketId: ticketId,
            isFullScreen: true
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
          error: new Error("id is undefined")
        });
      }
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("TicketList") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_TICKETING",
      component: _TicketListScreen.TicketListScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("TicketTypes") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "CONFIGURE_TICKETING",
      component: _TicketTypesScreen.TicketTypesScreen
    })
  })), children);
}